import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IWastyCarrier} from "../../../../../../utils/interfaces/special_wasty/wasty_carrier/IWastyCarrier";


const useApiCreateWastyCarrier = (): UseMutationResult<IWastyCarrier, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IWastyCarrier> {
        try {
            const response = await post(`/api/company/${companyToken}/special_wasty/wasty_carrier`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IWastyCarrier, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },
            onSuccess: async (obj) => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetWastyCarriers"]});
            },
        }
    );
};


export default useApiCreateWastyCarrier;